import utils from '@tencent/iwan-act-utils';

export default {
  name: '@tencent/iwan-act-utils-test',
  install: (VueConstructor: any, options = { env: 'test' }) => {
    const Vue = VueConstructor;
    const {
      env,
    } = options;
    const actContext = utils.initContext(env);
    if (Vue.prototype) {
      Vue.prototype.$actContext = actContext;
      Vue.prototype.$utils = utils;
    } else {
      Vue.config.globalProperties.$actContext = actContext;
      Vue.config.globalProperties.$utils = utils;
    }
    window.$actContext = actContext;
    window.$utils = utils;
  },
};
